// extracted by mini-css-extract-plugin
module.exports = {"root":"Gallery_root__W3cNf","gallery":"Gallery_gallery__H74xe","title":"Gallery_title__2_Tbe","txt":"Gallery_txt__3Gz22"};